export enum SystemPermission {
  STOP = "stop-coop",
  SIGN = "signature-config",
}
